import React from 'react'
import styled from 'styled-components'
import { stripUnit } from 'polished'
import { Link } from 'gatsby'

import * as spacing from 'styles/spacing'
import { white, grey, greyDark, borderColor } from 'styles/colors'
import { animationTime, animationCurve, navHeight, boxShadow, borderRadius } from 'styles/global'
import { mediaDown } from 'styles/media'
import NavLabel from './NavLabel'

const Container = styled.div`
  position: relative;
  flex-shrink: 0;

  ${mediaDown.medium`
    display: none;
  `};

  &:hover:before {
    content: '';
    display: block;
    position: absolute;
    left: -30px;
    right: -30px;
    top: 0;
    bottom: 0;
    cursor: pointer;
  }
`

const Trigger = styled.span`
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  text-align: left;
  height: ${navHeight};
  cursor: pointer;
  transition: color ${animationTime} ${animationCurve};
`

const Dropdown = styled.div`
  background-color: ${white};
  border: 1px solid ${borderColor};
  top: 100%;
  left: 50%;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  position: absolute;
  padding: ${spacing.large};
  transition: opacity ${animationTime} ${animationCurve}, visibility ${animationTime} ${animationCurve};
  width: 180px;
  margin-top: -${spacing.small};
  margin-left: -90px;
  z-index: 10;
  color: ${grey};
  border-radius: ${borderRadius};
  overflow: hidden;
  ${boxShadow};

  ${Container}:hover &,
  ${Container}:focus & {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
  }
`

const Item = styled(Link)`
  display: block;
  width: 100%;
  text-align: left;
  transition: color ${animationTime} ${animationCurve};

  &:hover {
    color: ${greyDark};
  }

  & + & {
    margin-top: ${stripUnit(spacing.small) * 1.5 + 'px'};
  }
`

const RewardsDropdown = () => (
  <Container>
    <Trigger>
      <NavLabel>Why Shop Online?</NavLabel>
    </Trigger>

    <Dropdown>
      <Item to="/vuse-plus-vape-deals/" data-tracking="nav--link--text--Vype_Plus">
        Vuse+
      </Item>

      <Item to="/benefits/" data-tracking="nav--link--text--Benefits">
        Benefits
      </Item>

      {/* <Item to="/referral" data-tracking="nav--link--text--Savings">
        Savings
      </Item> */}
    </Dropdown>
  </Container>
)

export default RewardsDropdown
